import { jsx as _jsx } from "react/jsx-runtime";
export const RiveEmbed = ({ contentInfo, originalUrl }) => {
    const parameters = new URLSearchParams({
        embed_host: 'Contra Test',
        src: contentInfo.url,
        url: originalUrl,
    });
    const iframeUrl = new URL('https://www.figma.com/embed');
    iframeUrl.search = parameters.toString() + '&allowfullscreen';
    return (_jsx("iframe", { allow: "fullscreen; picture-in-picture", loading: "lazy", sandbox: "allow-same-origin allow-scripts", src: contentInfo.url, style: {
            background: '#1b1a1b',
            border: 'none',
            borderRadius: 6,
            boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1)',
            height: 400,
            width: '100%',
        } }));
};
//# sourceMappingURL=RiveEmbed.js.map